<button type="button" class="close btn" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
</button>
<div class="success-message">
    <span><i class="bx bx-check"></i></span>
    <h4>Product Enquire Successfully</h4>
</div>
